import { render, staticRenderFns } from "./VInput.vue?vue&type=template&id=6827ed70&"
import script from "./VInput.vue?vue&type=script&lang=ts&"
export * from "./VInput.vue?vue&type=script&lang=ts&"
import style0 from "./VInput.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports